import en from './strings.en';

const ru = {
    pay: 'Оплатить доступ',
    cost: {
        begin: 'спишется',
        end: 'рублей'
    },
    discount: 'скидка',
    showInfo: 'показать информацию',
    payError: 'Невозможно произвести оплату, попробуйте позже',
};

export default { ru, en: { ...ru, ...en} };
